import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { DocumentViewer } from "../../Components/DocumentViewer/DocumentViewer";
import Loader from "../../Components/Loader/Loader";
import { GetPublicDocumentUrlService } from "../../Services/PublicDocumentService/PublicDocumentService";
import "./PublicImageViewer.css";

export const PublicDocument = () => {
  const { id: shortId } = useParams<{ id: string }>();
  const [url, setUrl] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!shortId) {
      setLoading(false);
      return;
    }

    GetPublicDocumentUrlService(shortId).then((data) => {
      setUrl(data || null);
      setLoading(false);
    });
  }, [shortId]);

  if (loading) return <Loader />;
  if (!url) return <div className="public-doc-message">Document not found.</div>;

  return (
    <div className="public-doc-page">
      <DocumentViewer urls={[url]} />
    </div>
  );
};
